package common.dto

import kotlinx.serialization.Serializable

@Serializable
data class Vec2d(
    val x: Double = 0.0, val y: Double = 0.0
) {
    override fun equals(other: Any?) = other is Vec2d && other.x == x && other.y == y
    override fun hashCode() = 31 * x.hashCode() + y.hashCode()
}